import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Legal from "@/pages/Legal";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AppLayout from "@/layouts/AppLayout";
import Today from "@/pages/app/Today";
import Crm from "@/pages/app/Crm";
import Opportunities from "@/pages/app/Opportunities";
import Channels from "@/pages/app/Channels";
import Team from "@/pages/app/Team";
import JoinTeam from "@/pages/JoinTeam";
import Brain from "@/pages/app/Brain";
import Metrics from "@/pages/app/Metrics";
import Account from "@/pages/app/Account";
import Admin from "@/pages/app/Admin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/acceso" element={<Login />} />
            <Route path="/registro" element={<Register />} />
            <Route path="/recuperar" element={<ForgotPassword />} />
            <Route path="/restablecer" element={<ResetPassword />} />
            <Route path="/unirse" element={<JoinTeam />} />
            <Route path="/aviso-legal" element={<Legal doc="aviso" />} />
            <Route path="/privacidad" element={<Legal doc="privacidad" />} />
            <Route path="/terminos" element={<Legal doc="terminos" />} />
            <Route path="/cookies" element={<Legal doc="cookies" />} />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/app/hoy" replace />} />
              <Route path="hoy" element={<Today />} />
              <Route path="crm" element={<Crm />} />
              <Route path="oportunidades" element={<Opportunities />} />
              <Route path="canales" element={<Channels />} />
              <Route path="brain" element={<Brain />} />
              <Route path="metricas" element={<Metrics />} />
              <Route path="cuenta" element={<Account />} />
              <Route path="admin" element={<Admin />} />
              <Route path="equipo" element={<Team />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
